module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.acf3dcb7.svg";